import { FC, useState } from "react";
import AddCard from "../AddCard";
import HistoryDialog from "./HistoryDialog";
import { Responses } from "../../types";

interface AddAttackCardProps {
  addPatientHistory: (responses: Responses) => void;
}

const AddAttackCard: FC<AddAttackCardProps> = ({ addPatientHistory }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <AddCard onClick={handleOpen} />
      <HistoryDialog
        addPatientHistory={addPatientHistory}
        handleClose={handleClose}
        open={open}
        variant="add"
      />
    </>
  );
};

export default AddAttackCard;
